import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon, TextWithHighlight } from '@dixa/lib-shared-habla';
import { getHighestUserRole, USER_ROLE_ATTRIBUTES } from 'lib-shared-user-role';
import { createAppUrl } from 'utils/url/createAppUrl';
import { useAppSearchParams } from 'utils/url/useAppSearchParams';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';
import { ContactsListItem } from '../../../listItem/contactsListItem';
import styles from './contactsUser.module.scss';
export function ContactsUser({ user, selected, }) {
    const { id, email, phone_number, roles } = user;
    const highestRole = getHighestUserRole(roles !== null && roles !== void 0 ? roles : []);
    const userRoleName = highestRole !== 'enduser'
        ? USER_ROLE_ATTRIBUTES[highestRole].prettyName
        : undefined;
    const contactOptions = [email, phone_number].filter(Boolean);
    const remainingContactOptionsLength = contactOptions.slice(1).length;
    const secondaryLabelText = contactOptions[0];
    const primaryLabelText = getUserDisplayName(user);
    // TODO (TEAMS-6149): Add new banned status once we transition to Postgres.
    // Until then hide the status icon entirely.
    const bannedIcon = false && _jsx(Icon, { className: styles.banIcon, name: "ban" });
    const { params: { q: searchTerm = '' }, } = useAppSearchParams('/contacts/user/:id');
    return (_jsx(ContactsListItem, { primaryLabel: _jsxs("div", Object.assign({ className: styles.label }, { children: [_jsx("span", Object.assign({ className: styles.ellipsis }, { children: _jsx(TextWithHighlight, { text: primaryLabelText, highlight: searchTerm }) })), bannedIcon] })), secondaryLabel: secondaryLabelText &&
            primaryLabelText !== secondaryLabelText && (_jsxs("div", Object.assign({ className: styles.label }, { children: [_jsx("span", Object.assign({ className: styles.ellipsis }, { children: _jsx(TextWithHighlight, { text: secondaryLabelText, highlight: searchTerm }) })), !!remainingContactOptionsLength && (_jsxs("span", Object.assign({ className: styles.more }, { children: ["+", remainingContactOptionsLength, " more"] })))] }))), avatar: {
            id: user.id,
            avatar_url: user.avatar_url,
            name: user.display_name,
            phone_number: user.phone_number,
        }, linkTo: createAppUrl({
            path: '/contacts/user/:id',
            params: {
                path: { id },
                search: { q: searchTerm },
            },
        }), selected: selected, badgeText: userRoleName }));
}
